import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { defineComponent as e } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const i = e({
  render() {
    var o, r;
    return (r = (o = this.$slots).default) === null || r === void 0 ? void 0 : r.call(o);
  }
});
export {
  i as Wrapper
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/wrapper.js
// module id = 903
// module chunks = 41